import { Box, Text } from '@factorialco/deprecated-design-system'
import { UpsellLandingPage } from 'generated/resources/graphql'

interface LaunchesWithCEOPageHeaderProps {
  content: UpsellLandingPage | undefined
}

const LaunchesWithCEOPageHeader = ({ content }: LaunchesWithCEOPageHeaderProps) => {
  const videoId = content?.mediaUrl?.split('v=')[1]?.split('&')[0]

  return (
    <Box className="mx-auto" alignItems="center" textAlign="center" gap="s16">
      <Text size="700" color="black" weight="bold">
        {content?.title || ''}
      </Text>
      <Box maxWidth="s600">
        {content?.description && (
          <Text size="400" className="mb-4">
            {content?.description || ''}
          </Text>
        )}
      </Box>

      <Box borderRadius={{ all: 'abs016' }} className="max-h-[450px] w-[800px]" position="relative">
        {videoId ? (
          <iframe
            width="793px"
            height="446px"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}`}
            allowFullScreen
            style={{
              borderRadius: '20px 20px 20px 20px',
            }}
          />
        ) : (
          <video
            src={content?.media?.url || ''}
            className="rounded-lg max-h-[450px]"
            style={{
              display: 'block',
              width: '100%',
              height: '100%',
              borderRadius: '8px',
              justifyContent: 'center',
            }}
            autoPlay
            muted
            loop
          />
        )}
      </Box>
    </Box>
  )
}

export default LaunchesWithCEOPageHeader
